import { posthog } from "posthog-js";

const DEFAULT_POSTHOG_HOST = "https://us.i.posthog.com";

export const startAnalytics = () => {
  const key = import.meta.env.VITE_POSTHOG_KEY;
  if (!key || posthog.__loaded) {
    return;
  }
  posthog.init(key, {
    api_host: import.meta.env.VITE_POSTHOG_HOST || DEFAULT_POSTHOG_HOST,
    capture_pageview: "history_change",
    disable_session_recording: true,
    person_profiles: "identified_only",
  });
};
